import { render } from "./CriticalCases.vue?vue&type=template&id=0c25ba64"
import script from "./CriticalCases.vue?vue&type=script&lang=js"
export * from "./CriticalCases.vue?vue&type=script&lang=js"

import "./CriticalCases.vue?vue&type=style&index=0&id=0c25ba64&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/cases/CriticalCases.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c25ba64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c25ba64', __exports__)) {
    console.log('reload')
    api.reload('0c25ba64', __exports__)
  }
  
  module.hot.accept("./CriticalCases.vue?vue&type=template&id=0c25ba64", () => {
    console.log('re-render')
    api.rerender('0c25ba64', render)
  })

}


export default __exports__